import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import ModelDataSourcePropertyBase from "./ModelDataSourcePropertyBase";

import { sampleData } from "./SampleData";

import { parseQueryResultToCommonResult } from '../utils/helper';

export default class Model extends ModelDataSourcePropertyBase {

    data = new PropertyDescriptor(sampleData, "静态数据（JSON 格式）", "高级", "jsonobject", "#anticon-json-", {
        description: "使用静态数据作为部件的数据源，静态数据请使用 JSON 语法",
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    loadData(opts) {
        return new Promise((resolve, reject) => {
            resolve(parseQueryResultToCommonResult(this.data));
        });
    }
}
